<script>
import { Toast } from 'vant'
import ImageNameLinkSelector from '@/components/org/ImageNameLinkSelector'
import MatchNameInput from '@/components/org/MatchNameInput'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-name-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'image-name-link-selector': ImageNameLinkSelector,
        'match-name-input': MatchNameInput,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {
                organizationId: null,
                organizationName: null,
                organizationLogoUrl: null,
                organizationAreaId: null,
                brandId: null,
                brandName: null,
                brandLogoUrl: null,
                year: null,
                session: null,
                name: null
            },
            hideOrganization: false,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        submitBtnClass() {
            return {
                'van-button--disabled': !this.validateSubmitRequired()
            }
        },
        organizationSelectorClass() {
            return {
                'hide': this.hideOrganization
            }
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.match.organizationId) {
                    Toast(this.locale['match-organization-required'])
                }
                else if (!this.match.brandId) {
                    Toast(this.locale['match-brand-required'])
                }
                else if (!this.match.name) {
                    Toast(this.locale['match-name-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onOrganizationClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListOrganization',
                    query: {
                        from: 'OrgCreateMatchName'
                    }
                }
            })
        },
        onMatchBrandClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgListMatchBrand',
                    query: {
                        from: 'OrgCreateMatchName'
                    }
                }
            })
        },
        onMatchNameDataChange(value) {
            // console.log('onMatchNameDataChange', value)
            this.match.name = value.name
            this.match.year = value.year
            this.match.session = value.session
        },

        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.match.organizationId 
                && this.match.brandId 
                && this.match.name) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'submit',
                    data: {
                        organizationId: this.match.organizationId,
                        matchBrandId: this.match.brandId,
                        matchName: this.match.name,
                        matchBrandName: this.match.brandName,
                        matchBrandLogoUrl: this.match.brandLogoUrl,
                        year: this.match.year,
                        session: this.match.session
                    }
                })
            }
        },
    },
}
</script>

<template>
    <div class="match-name-edit">
        <!-- match basic info -->
        <div class="basic-info">
            <image-name-link-selector
                :class="organizationSelectorClass"
                class="b-outer-margin"
                :label="locale['match-organization-label']"
                :name="match.organizationName"
                :imageUrl="adjustImageSize(match.organizationLogoUrl, 60, 60)"
                @click-link="onOrganizationClick"
            />
            <match-name-input
                :matchBrandName="match.brandName"
                :matchBrandLogoUrl="adjustImageSize(match.brandLogoUrl, 60, 60)"
                :matchYear="match.year"
                :matchSession="match.session"
                :disabled="!match.organizationId"
                @click-link="onMatchBrandClick"
                @change-data="onMatchNameDataChange"
            />
        </div>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['create-match-name-label']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
    </div>
</template>